<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="row margin-b">
                    <div class="col-md-12">
                        <app-sub-header title="Ministry Directory"></app-sub-header>

                        <div class="display">
                            <div>
                                <input #movieSearchInput type="search" placeholder="Search" class="form-control">
                            </div>
                            <div class="margin-l">
                                <div class="cursor" routerLink="filter"> <i class="fas fa-sliders-h"></i>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 col-xs-12">
                        <app-no-results-found *ngIf="objArr?.length == 0 && loading" hide ="fellow" title='Felloship'>
                        </app-no-results-found>


                        <div *ngIf="!loading">
                            <div *ngFor="let props of arr">
                                <app-card-skelton></app-card-skelton>
                            </div>
                        </div>
                        <div class="col-md-12" *ngIf="loading">
                            <div *ngFor="let props of (objArr | paginate
        : {
            itemsPerPage: pageSize,
            currentPage: pageNo,
            totalItems: totalItems
          }); let i = index">
                                <app-alert-card size=2 [showtext]=true [data]="props" title="Claim" [others]="false"
                                    [sideButton]="true" [route]="route" key="fellow"
                                    (getBlock)="getBlockCommunity($event)" (getReport)="getReportCommunity($event)"
                                    (getUnblock)="getunblockCommunity($event)">

                                </app-alert-card>
                            </div>
                        </div>
                        <div *ngIf="objArr.length > 2" class="col-md-12" style="text-align: center;">
                            <!-- <app-pagination [maxSize]="pageSize" (pageChange)="page = onChange($event)"></app-pagination> -->
                            <pagination-controls class="col s12 col-md-offset-3 my-pagination"
                                *ngIf="objArr?.length > 0 " (pageChange)="page = setPagination($event)"
                                directionLinks="true" autoHide="false" responsive="true" previousLabel="Previous"
                                nextLabel="Next" screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                                screenReaderCurrentLabel="You're on page">
                            </pagination-controls>
                        </div>



                    </div>
                </div>


            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>


<!-- 
<ng-template #mymodal let-modal>
    <div class="modal-header main-backgroundcolor">
        <h4 class="modal-title color" id="modal-basic-title">Filters</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true" class="color">&times;</span>
        </button>
    </div>
    <div class="modal-body">


        <app-shared-filter [LatLng]="defaultBounds" (setAddress)="outputData($event)"></app-shared-filter>




    </div>

    <div class="modal-footer">

    </div>
</ng-template> -->